module.exports = function hasWhitespacesOnly(value) {
  return String(value).trim().length === 0;
};
